import styled from 'src/style';
import { mediaQueries } from 'src/style/breakpoints';

export const CTAContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
});

export const CTABtnWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [mediaQueries.tabletPortraitUp]: {
    flexDirection: 'row',
  },
});

export const CTAInfoContent = styled.div({
  textAlign: 'center',
  marginTop: 140,
  width: '100%',
  [mediaQueries.phoneOnly]: {
    marginBottom: '10px',
    marginTop: 90,
  },
});
